The occupational categories of the job.
